export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const GET_LIVE_LISTING_COUNT = 'GET_LIVE_LISTING_COUNT'
export const GET_PAST_LISTING_COUNT = 'GET_PAST_LISTING_COUNT'
export const GET_ARTIST = 'GET_ARTIST'
export const GET_ALL_ARTIST = 'GET_ALL_ARTIST'
export const GET_ARTIST_NEWS = 'GET_ARTIST_NEWS'
export const CLEAR_ARTIST_NEWS = 'CLEAR_ARTIST_NEWS'
export const GET_ARTIST_METRIC_HISTORY = 'GET_ARTIST_METRIC_HISTORY'
